import { render, staticRenderFns } from "./StaffCompanyInstructionResponse.vue?vue&type=template&id=531f3a02&scoped=true&"
import script from "./StaffCompanyInstructionResponse.vue?vue&type=script&lang=js&"
export * from "./StaffCompanyInstructionResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531f3a02",
  null
  
)

export default component.exports